import { SearchPatientInGateway } from 'domain/usecases/patient/search-patient-in-gateway'
import { PatientRepository } from 'repository/interfaces/patient-repository'
import { SearchPatient } from 'domain/usecases/patient/search-patient'

export class RemoteSearchPatientInGateway implements SearchPatientInGateway {
  constructor(private readonly patientRepository: PatientRepository) {}

  load(params: SearchPatient.Params): Promise<SearchPatient.Model> {
    return this.patientRepository.searchPatientsInGateway(params)
  }
}
